import { Stack } from '@startuptools/ui/Stack';
import { type ComponentProps, Suspense } from 'react';
import { useOptionsDocumentsSuspenseQuery } from './OptionsDocuments.graphql';
import { useCompanyId } from '@startuptools/common/react-wrapper';
import { OptionsRegistrationDocuments } from './OptionsRegistrationDocuments';
import { OptionsSharesRegistrationDocuments } from './OptionsSharesRegistrationDocuments';

export const OptionsDocumentsPageInner = ({
  warrantProgramId,
  navigateToDecisionStep,
}: {
  warrantProgramId: string;
  navigateToDecisionStep: () => void;
}) => {
  const companyId = useCompanyId();
  const {
    data: { optionsRegistrations, optionsSharesRegistrations },
  } = useOptionsDocumentsSuspenseQuery({
    variables: { companyId, warrantProgramId },
    fetchPolicy: 'cache-and-network',
  });

  return (
    <Stack gap={3}>
      {optionsSharesRegistrations.map(osr => (
        <OptionsSharesRegistrationDocuments
          key={osr.id}
          optionsSharesRegistration={osr}
          navigateToDecisionStep={navigateToDecisionStep}
        />
      ))}
      {optionsRegistrations.map(or => (
        <OptionsRegistrationDocuments
          key={or.id}
          optionsRegistration={or}
          navigateToDecisionStep={navigateToDecisionStep}
        />
      ))}
    </Stack>
  );
};

export const OptionsDocumentsPage = (props: ComponentProps<typeof OptionsDocumentsPageInner>) => {
  return (
    <Suspense>
      <OptionsDocumentsPageInner {...props} />
    </Suspense>
  );
};
